import { RepoFile } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";

import SpaceliftVcsRepoFileRowActions from "../../../components/FileRowActions";

const RowActionsCell = ({ item, ...cellProps }: TableSimpleCellProps<RepoFile>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <SpaceliftVcsRepoFileRowActions filePath={item.filePath} />
    </TableSimpleCell>
  );
};

export default RowActionsCell;
